import { render, staticRenderFns } from "./VarietiesReport.vue?vue&type=template&id=47b8f184&"
import script from "./VarietiesReport.vue?vue&type=script&lang=js&"
export * from "./VarietiesReport.vue?vue&type=script&lang=js&"
import style0 from "./VarietiesReport.vue?vue&type=style&index=0&id=47b8f184&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports